import { BaseApiService } from "./BaseApiService";
import { PREFIX } from "utils/Const";
import {
  IAuthenticate,
  IAuthenticateRequest,
  IChangePasswordRequest,
  IThirdPartyAuthenticationRequest,
} from "model";

export const prefix = PREFIX.identity;

const getUrl = (url: string) => {
  return `${prefix}/${url}`;
};
const URL_AUTHENTICATE = getUrl("authenticate");
const URL_MICROSOFT_AUTHENTICATE = getUrl("pingidentity-authenticate");
const URL_CHANGE_PASSWORD = getUrl("change-password");


class IdentityApiService extends BaseApiService {
  public login = (data: IAuthenticateRequest) =>
    this.post<IAuthenticateRequest, IAuthenticate>(URL_AUTHENTICATE, data);
  public loginWithPing = (data: IThirdPartyAuthenticationRequest) =>
    this.post<IThirdPartyAuthenticationRequest, IAuthenticate>(
      URL_MICROSOFT_AUTHENTICATE,
      data
    );

  public changePassword = (data: IChangePasswordRequest) =>
    this.post<IChangePasswordRequest, IAuthenticate>(URL_CHANGE_PASSWORD, data);
}

export default new IdentityApiService(false);
